// Client mirror of the server-side banned purpose phrase list.
// Server is the source of truth: supabase/functions/llc-formation-generate/index.ts
export const BANNED_PURPOSE_TERMS = [
  "tax free", "tax-free", "exempt from tax", "avoid taxes",
  "write off", "write-off", "irs", "loophole",
  "hide", "conceal", "protect from creditors", "creditor proof",
  "creditor-proof", "untouchable", "judgment proof", "judgment-proof",
];

export function findBannedPurposeTerm(text: string): string | null {
  if (!text) return null;
  const hay = text.toLowerCase();
  for (const term of BANNED_PURPOSE_TERMS) {
    if (hay.includes(term)) return term;
  }
  return null;
}
